
import TableList from "@components/templates/tablelist";
import { HttpGetShipDetail } from "@/service/billing";
import { mapGetters } from "vuex";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpGetShipDetail,
        interceptRequest(params) {
            const { EQ_billingDate } = params.search;
            params.search.LE_startTime = EQ_billingDate;
            params.search.GE_endTime = EQ_billingDate;
            delete params.search.EQ_billingDate;
            this.formData = params
            return params
        },
        handleOperates(params = "", type, batch) {

            switch (type) {
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/freightSettlement/item/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    })
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusWareList', 'getCusproductList', 'getOrgList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export',{defaultValue:'导出'}),
                    operate: "export",
                    theme: "info",
                    // batch: true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                    tag: 'vInput',
                    key: 'EQ_billNo',
                    show: true,
                },
                {
                    label: this.$t('fbb.billDelivery.trackingNo',{defaultValue:'运单号码'}),
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,
                },
                {
                    label: this.$t('fbb.billDelivery.sourceNo',{defaultValue:'关联单号'}),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    show: true,
                },
                {
                    label: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    tag: 'vDatepicker',
                    key: 'EQ_billingDate',
                    props: {
                        format: 'yyyy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [
            {
                title: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                key: 'billNo',
            },
            {
                title: this.$t('fbb.billDelivery.trackingNo',{defaultValue:'运单号码'}),
                key: 'trackingNo',
            },
            {
                title: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                render: (h,{row})=>{
                    return <div>{row.periodCode} ({row.startTime} ~ {row.endTime})</div>
                }   
            },
            {
                title: this.$t('fbb.billDelivery.costName',{defaultValue:'收费项'}),
                key: 'costName',
            },
            {
                title: this.$t('fbb.billDelivery.cost',{defaultValue:'收费金额(USD)'}),
                key: 'cost',
            },
            {
                title: this.$t('fbb.billDelivery.sourceNo',{defaultValue:'关联单号'}),
                key: 'sourceNo',
            },
            {
                title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                key: 'createdAt',
            },
            ];
        },

    },

};
